import { date as commonDate } from '@finley-technologies/common';
import {
  CreditFacility,
  CreditAgreement,
  Util,
} from '@finley-technologies/finley-types';

import { FullDateStr } from 'packages/common-frontend/components/InputsBETA/DateInput';

const PropertyType = CreditAgreement.DomainEntity.PropertyType;
type DateProperty = CreditAgreement.DomainEntity.DateProperty;
type TextProperty = CreditAgreement.DomainEntity.TextProperty;
type PercentageRateProperty = CreditAgreement.DomainEntity.PercentageRateProperty;
type StructureProperty = CreditAgreement.DomainEntity.StructureProperty;

export const fullDateStrToUTCDate = (date: Util.FullDateStr): Date => {
  const [year, month, day] = date.split('-');
  return new Date(
    Date.UTC(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10)),
  );
};

export const dateToFullDateString = (date: Date) =>
  commonDate.dateToFullDateString(date, 'UTC');

export const createCADateProperty = (
  value: FullDateStr,
  name: string,
  originalObj?: DateProperty,
): DateProperty => {
  // if an existing CA Property object exists, we reuse all of its existing
  // fields (like name, section, _isWrittenIn_), but still overwrite 'value'.
  if (originalObj) {
    return { ...originalObj, value };
  }

  return {
    name,
    type: PropertyType.DateProperty,
    _isWrittenIn_: true,
    value,
  };
};

export const createCATextProperty = (
  textValue: string,
  name: string,
  originalObj?: TextProperty,
): TextProperty => {
  if (originalObj) {
    return { ...originalObj, value: textValue };
  }

  return {
    name,
    type: PropertyType.TextProperty,
    _isWrittenIn_: true,
    value: textValue,
  };
};

export const createCAPercentageRateProperty = (
  value: number,
  name: string,
  originalObj?: PercentageRateProperty,
): PercentageRateProperty => {
  if (originalObj) {
    return { ...originalObj, value };
  }

  return {
    name,
    type: PropertyType.PercentageRateProperty,
    _isWrittenIn_: true,
    value,
  };
};

export const createCAStructureProperty = (
  structureValue: 'fixedProportion' | 'classed',
  name: string,
  originalObj?: StructureProperty,
): StructureProperty => {
  if (originalObj) {
    return {
      ...originalObj,
      // the string union of structureValue ensures that this cast is safe (as do the unit tests)
      value: structureValue as CreditFacility.CreditFacilityStructureType,
    };
  }

  return {
    name,
    type: PropertyType.StructureProperty,
    _isWrittenIn_: true,
    value: structureValue as CreditFacility.CreditFacilityStructureType,
  };
};
